import { motion } from "framer-motion";

import { GlassButton } from "@/components/glassButton";
import { PhoneFrame } from "@/components/phoneFrame";
import { useTracking } from "@/hooks/useTracking";
import { useTrackAccessSection } from "@/hooks/useTrackAccessSection";
import "./styles.scss";

const BULLETS = [
  "Nome, logo e cores personalizadas — passa profissionalismo",
  "Faturas, Pix, boleto e cartão dentro do app",
  "Provenduz publica, atualiza e mantém — zero dor técnica",
];

export const IspHero = () => {
  const { sendEvent } = useTracking();
  useTrackAccessSection(".isp-hero", "hero");

  const goToSimulator = () => {
    window.location.href = "#simulador";
    sendEvent("button_clicked", {
      event_category: "hero_section",
      event_label: "Montar meu app",
      event_action: "click",
      value: 1,
    });
  };

  return (
    <section id="inicio" className="isp-hero">
      <div className="isp-hero__inner">
        <motion.div
          className="isp-hero__copy"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="isp-hero__eyebrow">Provenduz ISP</span>
          <h1 className="isp-hero__title">
            O app do seu provedor, com a sua marca,{" "}
            <span className="isp-hero__title-grad">
              na Play Store e na App Store
            </span>
          </h1>
          <p className="isp-hero__lead">
            Seus clientes pagam a fatura, acompanham o consumo e resolvem o
            essencial sem abrir chamado. Você monta a prévia agora e publica em
            até 7 dias.
          </p>

          <motion.ul
            className="isp-hero__bullets"
            initial="hidden"
            animate="show"
            variants={{ show: { transition: { staggerChildren: 0.09, delayChildren: 0.3 } } }}
          >
            {BULLETS.map((b) => (
              <motion.li
                key={b}
                variants={{
                  hidden: { opacity: 0, x: -12 },
                  show: { opacity: 1, x: 0 },
                }}
                transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
              >
                <i className="bx bx-check" />
                <span>{b}</span>
              </motion.li>
            ))}
          </motion.ul>

          <div className="isp-hero__actions">
            <GlassButton variant="isp" href="#simulador" onClick={goToSimulator}>
              Montar meu app agora
            </GlassButton>
            <GlassButton variant="glass" href="#planos">
              Ver planos
            </GlassButton>
          </div>
        </motion.div>

        <motion.div
          className="isp-hero__device"
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        >
          <PhoneFrame variant="isp" floating>
            <div className="isp-hero__screen-top">
              <span>Rua xpto, 2000</span>
              <i className="bx bx-bell" />
            </div>
            <div className="isp-hero__screen-user">
              <span className="isp-hero__avatar" />
              <div>
                <strong>Olá, Gabriel</strong>
                <small>Sua fatura está em aberto</small>
              </div>
            </div>
            <div className="p-card isp-hero__invoice">
              <div className="isp-hero__invoice-head">
                <strong>Sua fatura</strong>
                <i className="bx bx-chevron-right" />
              </div>
              <div className="isp-hero__invoice-amount">
                <b>R$ 89,90</b>
                <span className="isp-hero__tag">Em aberto</span>
              </div>
              <small>Vencimento: 30 de Abril de 2024</small>
              <div className="isp-hero__invoice-actions">
                <span className="isp-hero__pay">Pagar</span>
                <span className="p-card isp-hero__details">Detalhes</span>
              </div>
            </div>
            <strong className="isp-hero__section-label">Acesso rápido</strong>
            <div className="isp-hero__quick">
              <span>
                <i className="bx bx-dollar-circle" />
                Financeiro
              </span>
              <span>
                <i className="bx bx-lock-alt" />
                Liberação
              </span>
              <span>
                <i className="bx bx-phone" />
                Contato
              </span>
            </div>
            <div className="isp-hero__usage">
              <div className="p-card">
                <b>435 Gb</b>
                <small>Download · Abril</small>
              </div>
              <div className="p-card">
                <b>58 Gb</b>
                <small>Upload · Abril</small>
              </div>
            </div>
          </PhoneFrame>
        </motion.div>
      </div>
    </section>
  );
};
